import Bind from 'bind.js';

export default class Menu {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.seperator = false;
    if (this.parentElement.dataset.seperator == "true") {
      this.seperator = true;
    }
    this.listClass = (this.parentElement.dataset.listItemClass)
                     ? (this.parentElement.dataset.listItemClass) : "";
    this.activePage = (this.parentElement.dataset.activeClass)
                      ? (this.parentElement.dataset.activeClass) : "";

    this.data = data;
    this.addContent();
  }

  addContent() {
    this.parentElement.innerHTML = "";
    this.editor = Bind(
      {
        links: this.data.links,
      },
      {
        links: function (links) {
          let linksCount = 0;
          for (var i = 0; i < links.length; i++) {
            if (!links[i].hide)
              linksCount++;
          }

          var addedLinks = 0;
          for (var i = 0; i < links.length; i++) {
            if (!links[i].hide) {
              addedLinks++;
              let activeLink = false;
              let listClass = this.listClass;
              let extraClasses = (links[i].class) ? links[i].class : "";
              let href = (links[i].href) ? links[i].href : "#";

              if (links[i].href !== "#" && links[i].href !== "" && links[i].href == this.activePage) {
                activeLink = true;
                listClass += " active";
              }

              let template = `<li class="${listClass}"><a class="alt ${extraClasses}"
                                     href="${href}">${links[i].title}</a></li>`;

              if (this.seperator && addedLinks !== linksCount && !activeLink) {
                template += `<li class="navseperator ${extraClasses}"> | </li>`;
              }

              if (activeLink) {
                if (this.parentElement.lastChild.className.indexOf("navseperator") > -1 ) {
                  this.parentElement.lastChild.remove();
                }
              }

              this.parentElement.innerHTML += template;
            }
          }
        }.bind(this)
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.links = data.links;
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Menu.js